__turbopack_context__.v({
  "className": "montserrat_164b1597-module__OnbUgG__className",
});
